export const DASHBOARD_TINY_UPSELLER = 'dashboard-tiny-upseller';
export const DASHBOARD_NOTIFICATION_BAR = 'dashboard-notification-bar';
export const DASHBOARD_HINT_BAR = 'dashboard-hint-bar';
export const DASHBOARD_HINT_BAR_PERSONAL_PROJECTS = 'dashboard-hint-bar-personal-projects';
export const DASHBOARD_SIDE_BAR = 'dashboard-side-bar';
export const ACCOUNT_HINT_BAR = 'account-hint-bar';
export const PROTOTYPE_HINT_BAR = 'prototype-hint-bar';
export const FREE_TRIAL_NOTIFICATION_BAR = 'free-trial-notification-bar';
export const FLOATING = 'floating';
